import { InjectionToken } from '@angular/core';

export const CONFIGURED_ENVIRONMENT = new InjectionToken<string>('Configured Environment');
export const CONFIGURED_CUSTOM_URL = new InjectionToken<string>('Configured Custom URL');
export const BASE_URL = new InjectionToken<string>('Base URL');